import React from "react";

// Modules
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";

// App
import {
  client,
  apiEndpoints,
  serverUrl,
  favoritesEnabled,
  counterEnabled,
} from "../../config";
import { getOnlineNode } from "../../core/getNode";
import Pagination from "../../partials/pagination";
import PageHeader from "../../partials/pageHeader";
import { alertMessages } from "../../partials/alertMessages";
import Error from "../../partials/error";
import NoData from "../../partials/noData";
import {
  getFavoritesByContentType,
  favoritesContentType,
} from "../../utils/helpers";
import LinkItem from "./linkItem";
import ScreenCategories from "../../partials/screenCategories";
import ClientTheme from "../../core/clientTheme";
import { patchNode } from "../../core/postNode";
import { PostContextProvider } from "../../contexts/postContext";
import { getEntityCategories } from "../../partials/posts/postHelpers";
import PostItemActions from "../../partials/posts/postItemActions";
import PostDelete from "../../partials/posts/postDelete";
import PostShare from "../../partials/posts/postShare";
import PostFilters from "../../partials/posts/postFilters";
import PostPublishing from "../../partials/posts/postPublish";
import PostSetting from "../../partials/posts/postSetting";
import {
  filterParams,
  parseVocabularies,
} from "../../partials/posts/postHelpers";

// UI components
import Row from "react-bootstrap/Row";
import CompanyappLoader from "../../partials/companyappLoader";
import NestedCategory from "../../partials/nestedCategory";

const contentType = favoritesContentType("link");
const pageSize = 20;

export default function LinksCreator(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [categories, setCategories] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [sitas, setSitas] = useState([]);
  const [references, setReferences] = useState([]);
  const [data, setData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const user = useSelector((state) => state).authReducer.user;
  const favorites = useSelector((state) => state).favoritesReducer;
  const counter = useSelector((state) => state).counterReducer;
  const permissions = useSelector((state) => state).permissionsReducer
    .permissions;
  const entityFiltersReducer = useSelector((state) => state)
    .entityFiltersReducer.links;
  const favStrings = getFavoritesByContentType(favorites, contentType, true);
  const clientTheme = { ...ClientTheme() };

  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (counterEnabled) {
      updateRemoteCounter();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getContent(1);
  }, [entityFiltersReducer]);

  useEffect(() => {
    if (categories.length <= 1) {
      getEntityCategories({
        user,
        setCategories,
        setLanguages,
        setSitas,
        setReferences,
        _setError,
        targetVid: "link_categories",
      });
    }
    if ((activeIndex === 1 && favStrings !== "") || activeIndex === 0) {
      getContent(1);
    } else {
      setData([]);
      setIsLoading(false);
    }
    // eslint-disable-next-line
  }, [activeIndex]);

  useEffect(() => {
    if (activeIndex === 1) {
      if (favStrings !== "") {
        getContent(1);
      } else {
        setData([]);
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line
  }, [favStrings]);

  /**
   * @function setError
   * @description Updates the state of the component upon an error
   * @param {boolean} _isError
   * @param {int} _errorStatus
   * @param {string} _errorMessage
   */
  const _setError = (_isError, _errorStatus, _errorMessage) => {
    setIsLoading(false);

    setIsError(_isError);
    setErrorStatus(_errorStatus);
    setErrorMessage(_errorMessage);
  };

  /**
   * @function getContent
   * @description Retrieves the data from an API / Fallback to local realm object if there is no connection
   */
  const getContent = (_currentPage) => {
    setIsLoading(true);
    let path;

    if (client === "companyapp") {
      path = `${apiEndpoints.links}?items_per_page=${pageSize}&page=${_currentPage - 1}`;

      const tid = selectedCategory;
      if (activeIndex === 1) {
        path = `${apiEndpoints.links}?id=${favStrings}&items_per_page=${pageSize}&page=${_currentPage - 1}`;
      }
    } else {
      path = `${
        apiEndpoints.links
      }?status=1&promote=1&items_per_page=${pageSize}&page=${_currentPage - 1}`;

      const tid = selectedCategory;
      if (tid !== 0) {
        path = `${
          apiEndpoints.links
        }/${tid}/all?status=1&promote=1&items_per_page=${pageSize}&page=${
          _currentPage - 1
        }`;
      }
      if (activeIndex === 1) {
        path = `${
          apiEndpoints.links
        }/all/${favStrings}?status=1&promote=1&items_per_page=${pageSize}&page=${
          _currentPage - 1
        }`;

        if (tid !== 0) {
          path = `${
            apiEndpoints.links
          }/${tid}/${favStrings}?status=1&promote=1&items_per_page=${pageSize}&page=${
            _currentPage - 1
          }`;
        }
      } else {
        if (tid !== 0) {
          path = `${
            apiEndpoints.links
          }/${tid}/all?status=1&promote=1&items_per_page=${pageSize}&page=${
            _currentPage - 1
          }`;
        }
      }
    }

    path = filterParams(entityFiltersReducer, path);

    getOnlineNode(path, user.access_token)
      .then((response) => {
        // dataHandler(response.data);
        setData(response.data.rows);
        setTotalItems(response.data.pager.total_items);
        setIsLoading(false);
      })
      .catch((_error) => {
        console.log("content error: ", _error);
        if (_error.response) {
          //console.log('@rest response: ', _error.response);
          _setError(true, _error.response.status, _error.response.statusText);
        } else if (_error.request) {
          //console.log('@rest request: ', _error.request);
          _setError(true, 0, alertMessages.requestError.message);
        } else {
          //console.log('@rest unknown: ', _error);
          _setError(true, 0, alertMessages.unkownError.message);
        }
      });
  };

  /**
   * @function onPaginate
   * @description Pagination callback
   * @param {int} _index - Page number
   */
  const onPaginate = (_index) => {
    setIsLoading(true);

    setCurrentPage(_index);
    getContent(_index);
  };

  /**
   * @function handleCategorySelection
   * @description Modal Picker callback / Updates the header title and sets the state to the selected category
   * @param {string} _id - Category ID
   */
  const handleCategorySelection = (value) => {
    setIsLoading(true);

    setIsError(false);
    setCurrentPage(1);
  };

  // Pagination component
  const renderPagination = () => {
    if (totalItems <= pageSize) {
      return null;
    } else {
      return (
        <Pagination
          owner="client"
          containerClasses={`creator-pagination d-flex justify-content-center align-items-center mt-4`}
          previousDisabled={currentPage === 1 ? true : false}
          nextDisabled={data.length < pageSize ? true : false}
          currentPage={currentPage}
          onPrevious={() => {
            onPaginate(currentPage - 1);
          }}
          onNext={() => {
            onPaginate(currentPage + 1);
          }}
        />
      );
    }
  };

  const dataComponent = () => {
    if (typeof data !== "undefined" && data.length > 0) {
      return (
        <Row>
          {data.map((item, index) => {
            return (
              <React.Fragment key={`link-${index}`}>
                <LinkItem
                  creator={true}
                  item={{
                    ...item,
                    is_share_enabled: true,
                    isViewEnabled: true,
                    creatorActionsEnabled: true,
                  }}
                  user={user}
                  contentType={contentType}
                />
              </React.Fragment>
            );
          })}
        </Row>
      );
    } else {
      return <NoData activeIndex={activeIndex} />;
    }
  };

  // Updates content counter
  const updateRemoteCounter = () => {
    const updateData = {
      contentType: "link",
      acknowledgedCount: counter?.contentCounts?.link || 0,
    };

    patchNode(`${serverUrl}/api/v2/counter`, updateData, user.csrf_token)
      .then((response) => {
        if (response.data) {
          dispatch({ type: "UPDATE_COUNTER", payload: response.data });
        }
      })
      .catch((error) => {
        // console.log('error: ', error);
      });
  };

  return (
    <>
      {isError ? (
        <Error status={errorStatus} message={errorMessage} />
      ) : (
        <main className="links  screen">
          <PostContextProvider
            editRoute={"/links/edit"}
            previewRoute={"/links/preview"}
            viewRoute={"/links"}
            entityType={"link"}
          >
            <PageHeader
              pageName="Link Library"
              filters={true}
              owner="client"
              pageNameColor="clientHeadingScreens"
              svgLogo={clientTheme.pageLogos.svg}
              pageLogo={clientTheme.pageLogos.links}
              enableFavorites={favoritesEnabled}
              toggleSwitch={true}
              switchLink={`/links`}
              switchStatus={true}
              contentTypeName={"link"}
              createNew={true}
              handleCreate={() => {
                navigate(`/links/add`);
              }}
              hasSearch={true}
              nestedCategorySelector={true}
              searchEntityType="links"
              categories={categories}
              categoryTitle="Links"
              categoryName="links"
              getFavourites={() => {
                setActiveIndex(activeIndex === 0 ? 1 : 0);
                setIsLoading(true);
              }}
              activeTabIndex={activeIndex}
              postFilters={true}
              filterProps={{
                categories: categories,
                languages: languages,
                references: references,
                sitas: sitas,
                filterEntityType: "links",
                redux: true,
              }}
            />
            {isLoading ? (
              <CompanyappLoader />
            ) : (
              <>
                {dataComponent()}
                {renderPagination()}
              </>
            )}
            <PostPublishing
              publishPath={apiEndpoints.links}
              categories={categories}
              languages={languages}
              sitas={sitas}
              references={references}
              user={user}
              permissions={permissions}
              getContent={() => getContent(currentPage)}
            />
            <PostShare
              user={user}
              permissions={permissions}
            />
            <PostItemActions />
            <PostDelete
              deletePath={apiEndpoints.links}
              user={user}
              getContent={() => {
                setIsLoading(true);
                getContent(currentPage);
              }}
            />
            <PostSetting
              categories={categories}
              references={references}
              sitas={sitas}
              languages={languages}
              user={user}
              getContent={() => {
                setIsLoading(true);
                getContent(currentPage);
              }}
            />
          </PostContextProvider>
        </main>
      )}
    </>
  );
}
